// When a message was sent, as a Date.
//
// The server writes the time a message was saved with no time zone, as in
// "2026-10-03T09:18:02.524301", and its clock runs on UTC. A browser reads a
// time written that way as its OWN local time, so in Cairo every message
// loaded from history showed three hours early, beside a reply that arrived
// live and was stamped by the browser correctly: on 3 Oct a question showed
// 9:18 AM and its answer, seconds later, 12:18 PM. The same three hours also
// stopped the panel recognising the server's copy of a message it had just
// shown, which is one way a message appears twice.
//
// So a date-and-time with no zone is read as UTC. Anything that already says
// its zone, or is already a Date or a number, is taken as it is.

const DATE_AND_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;
const HAS_ZONE = /(Z|[+-]\d{2}(:?\d{2})?)$/i;

/**
 * @param {string|number|Date} value a message's createdAt
 * @returns {Date} the moment it was sent; an invalid Date when there is none
 */
export const messageTime = (value) => {
  if (value instanceof Date) return value;
  if (typeof value === "number") return new Date(value);
  if (typeof value !== "string" || !value) return new Date(NaN);
  const text = value.trim();
  return new Date(DATE_AND_TIME.test(text) && !HAS_ZONE.test(text) ? `${text}Z` : text);
};
